/**
 * Product polish — control sizes and graph chrome.
 * Values alias design-system/foundation.ts (CONTROL, RADIUS, MOTION).
 */
import { CONTROL, EASE, RADIUS } from '../foundation';

/** Minimum comfortable interactive target */
export const POLISH_TOUCH = CONTROL.button.md;

export const POLISH_BUTTON = {
  sm: { minHeight: CONTROL.button.sm, px: 1.5, fontSize: '0.8125rem', radius: RADIUS.control },
  md: { minHeight: CONTROL.button.md, px: 2, fontSize: '0.875rem', radius: RADIUS.control },
  lg: { minHeight: CONTROL.button.lg, px: 2.75, fontSize: '0.9375rem', radius: RADIUS.control },
} as const;

export const POLISH_PILL = {
  minHeight: CONTROL.button.sm,
  px: 1.5,
  fontSize: '0.8125rem',
  gap: 0.75,
} as const;

export const POLISH_GRAPH = {
  minHeight: 520,
  maxHeight: 680,
  controlSize: CONTROL.icon.sm,
} as const;

export const POLISH_GUTTER = {
  xs: 16,
  sm: 24,
  md: 32,
  lg: 40,
  xl: 48,
} as const;

export const POLISH_MOTION = {
  hover: `transform 0.18s ${EASE}, box-shadow 0.18s ease, background-color 0.15s ease`,
  press: 'transform 0.1s ease',
} as const;
